import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Appstore } from "../../redux/store";
import { ModifyEvent } from "../../redux/states/event.state";
import { IEvent } from "../../interfaces/models/IEvent";
import { IAddress } from "../../interfaces/models/IEvent";

export function useEventForm() {
  const dispatch = useDispatch();
  const event = useSelector((state: Appstore) => state.event);

  const updateEventField = useCallback(
    <K extends keyof IEvent>(key: K, value: IEvent[K]) => {
      dispatch(ModifyEvent({ [key]: value } as Partial<IEvent>));
    },
    [dispatch]
  );

  const updateEvent = useCallback(
    (payload: Partial<IEvent>) => {
      dispatch(ModifyEvent(payload));
    },
    [dispatch]
  );

  return { event, updateEvent, updateEventField };
}

export function useEventAddressForm() {
  const { event } = useEventForm();
  const dispatch = useDispatch();

  const updateEventAddress = useCallback(
    (payload: Partial<IAddress>) => {
      dispatch(
        ModifyEvent({ address: { ...(event.address || {}), ...payload } } as Partial<IEvent>)
      );
    },
    [dispatch, event.address]
  );

  const updateEventAddressField = useCallback(
    <K extends keyof IAddress>(key: K, value: IAddress[K]) => {
      dispatch(
        ModifyEvent({ address: { ...(event.address || {}), [key]: value } } as Partial<IEvent>)
      );
    },
    [dispatch, event.address]
  );

  return { address: event.address, updateEventAddress, updateEventAddressField };
}


